import { Component, EventEmitter, Output, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ApiService } from 'src/app/services/api.service';
import { localStorageService } from 'src/app/services/localstorage.service';
import { dobData, SharedService } from 'src/app/services/shared.service';
import { SocketsService } from 'src/app/services/socket.service';
import { LoaderService } from 'src/app/shared/loader/loader.service';
import { BrowserMultiFormatReader, DecodeHintType, BarcodeFormat, } from '@zxing/library';
import { Subject } from 'rxjs';
@Component({
    selector: 'app-upload-doc',
    templateUrl: './upload-doc.component.html',
    styleUrl: './upload-doc.component.scss',
    changeDetection: ChangeDetectionStrategy.Eager
})
export class UploadDocComponent {
  @Output() passEntry: EventEmitter<any> = new EventEmitter();

  selectedIdType: string = 'drivers_license';
  identityFiles: any = {};
  identityPreviews: any = {};
  currentStep: number = 1;
  public token: string = '';
  public display_logo: string = '';
  public disconect: boolean = false;
  confirmationModal!: BsModalRef;
  extra_data!: any;
  activeScans: number = 0;

  dobSubscription: Subject<any> = new Subject();
  dobData!: dobData;
  showDobError = false;
  modalType = '';
  contract_id: any;
  contract_patient_token: any;
  barCodeDetected :boolean = false

  private barcodeReader!: BrowserMultiFormatReader;
  private hints = new Map();
  constructor(
    private _shared: SharedService,
    private _api: ApiService,
    public _loader: LoaderService,
    private _socket: SocketsService,
    private route: ActivatedRoute,
    private bsModalRef: BsModalRef,
  ) {
    if (!this.modalType) {
      this.contract_id = this.route.snapshot.params['contract_id'];
      this.token = this.route.snapshot.params['token'];
      this.display_logo = this.route.snapshot.queryParams['currency'];
      this.contract_patient_token = this.route.snapshot.queryParams['contract_patient_token'];
    }
  }

  ngOnInit() {
    this.hints.set(DecodeHintType.POSSIBLE_FORMATS, [BarcodeFormat.PDF_417]);
    this.hints.set(DecodeHintType.TRY_HARDER, true);

    this.barcodeReader = new BrowserMultiFormatReader(this.hints);
    if (!this.modalType) {
      this._socket.emit(this._shared.socketIds.DL_LOADER, {
        token: this.token,
        loader: true,
        isDocUploaded:false,
        customer_data:{}
      });

      this._socket.on(this._shared.socketIds.DL_DATA_CANCEL, (data: any) => {
        this.disconect = true;
        this.confirmationModal?.hide();
      });

      this._socket.on('CONNECTED_USERS', (data: any) => {
        console.log('the data is', data);
        this.extra_data = data;
      });

    } else {
      this.contract_id = this.extra_data?.contract_id;
    }
  }

  onIdTypeChange() {
    this.identityFiles = {};
    this.identityPreviews = {};
    this.dobData = { month: '', day: '', year: '' };
    this.extra_data = null;
    this.showDobError = false;
    this.activeScans = 0;
  }

  onClose() {
    this.bsModalRef.hide();
  }

  getDob(event: any) {
    this.dobData = event;
    this.showDobError = false;
  }

  isImage(file?: File): boolean {
    return file ? file.type.startsWith('image/') : false;
  }

  removeIdentityFile(fileType: string) {
    delete this.identityFiles[fileType];
    delete this.identityPreviews[fileType];

    if (this.selectedIdType === 'drivers_license' && fileType === 'back') {
      this.barCodeDetected = false;
    }

    if (this.selectedIdType === 'drivers_license') {
      this.extra_data = null;
      this.dobData = { month: '', day: '', year: '' };
      this.showDobError = false;
    }
  }

  onIdentityFileSelected(event: any, fileType: string) {
    const input = event.target as HTMLInputElement;
    const file = input.files?.[0];
    if (!file) {
      return;
    }

    if (file.size > 10 * 1024 * 1024) {
      this._shared.customPopups('File size is too large, you can upload maximum 10MB file.', 1,);
      this.resetSelectedFile(fileType, input);
      return;
    }

    if ( file.type !== 'image/png' && file.type !== 'application/pdf' && file.type !== 'image/jpeg' && file.type !== 'image/jpg' ) {

      this._shared.customPopups('File type not supported (.pdf, .jpg, .jpeg, .png).',1,);
      this.resetSelectedFile(fileType, input);
      return;

    }

    this.identityFiles[fileType] = file;

    if (
      this.selectedIdType === 'drivers_license' &&
      this.identityFiles.front &&
      this.identityFiles.back &&
      this.areFilesSame(this.identityFiles.front, this.identityFiles.back)
    ) {
      this._shared.customPopups("Front and back side cannot be the same file.", 1);
      this.resetSelectedFile(fileType, input);
      return;
    }

    if (this.isImage(file)) {
      const reader = new FileReader();
      reader.onload = (e) => {
        this.identityPreviews[fileType] = e.target?.result as string;
      };

      reader.readAsDataURL(file);
      // AUTO SCAN IMAGE HERE
      this.decodeBarcodeFromFile(file, fileType);
    } else {
      this.identityPreviews[fileType] = file.name;
    }
    input.value = '';
  }

  get showDobForLicense(): boolean {
    if (this.selectedIdType === 'drivers_license') {
      const hasFiles = !!(this.identityFiles?.front && this.identityFiles?.back);
      const rawDob = this.extra_data?.['Date of Birth (MMDDYYYY)'];
      const hasDobData = rawDob && rawDob.length === 8;
      return hasFiles && !hasDobData && this.activeScans === 0;
    }
    return false;
  }
  uploadIdentity() {
  
    
    if (this.selectedIdType === 'drivers_license') {
      if (!this.identityFiles.front || !this.identityFiles.back) {
        this._shared.customPopups("Please upload both front and back side of the Driver's License.", 1,);
        return;
      }
      if (this.areFilesSame(this.identityFiles.front, this.identityFiles.back)) {
        this._shared.customPopups("Front and back side cannot be the same file.", 1);
        return;
      }
      
       if  (!this.barCodeDetected)  {
        this._shared.customPopups('Barcode not detected. Please upload a clear image of the back side of the Driver\'s License.', 1);
        return
      }
      // if (this.showDobForLicense) {
      //   if (!this.dobData || !this.dobData.month || !this.dobData.day || !this.dobData.year) {
      //     this.showDobError = true;
      //     return;
      //   }
      // }
    } else {
      if (!this.identityFiles.proof) {
        this._shared.customPopups('Please upload a proof of identity.', 1);
        return;
      }
      // if (!this.dobData || !this.dobData.month || !this.dobData.day || !this.dobData.year) {
      //   this.showDobError = true;
      //   return;
      // }
    }
    const response = {
      idType: this.selectedIdType,
      files: this.identityFiles,
    };
    this.uploadIdentityDocs(response);
  }

  uploadIdentityDocs(data: any) {
    const formData = new FormData();

    if (data.idType === 'drivers_license') {
      if (data.files.front) {
        formData.append('dl_front', data.files.front);
      }
      if (data.files.back) {
        formData.append('dl_back', data.files.back);
      }
    } else {
      if (data.files.proof) {
        formData.append('proof_of_id', data.files.proof);
      }
    }

    // let dob = '';
    // if (data.idType === 'drivers_license') {
    //   const rawDob = this.extra_data?.['Date of Birth (MMDDYYYY)'];
    //   if (rawDob && rawDob.length === 8) {
    //     const month = rawDob.substring(0, 2);
    //     const day = rawDob.substring(2, 4);
    //     const year = rawDob.substring(4, 8);
    //     dob = `${year}-${month}-${day}`;
    //   } else if (this.dobData) {
    //     const month = String(this.dobData.month).padStart(2, '0');
    //     const day = String(this.dobData.day).padStart(2, '0');
    //     const year = this.dobData.year;
    //     if (this.dobData.month && this.dobData.day && this.dobData.year) {
    //       dob = `${year}-${month}-${day}`;
    //     }
    //   }
    // } else {
    //   if (this.dobData) {
    //     const month = String(this.dobData.month).padStart(2, '0');
    //     const day = String(this.dobData.day).padStart(2, '0');
    //     const year = this.dobData.year;
    //     dob = `${year}-${month}-${day}`;
    //   }
    // }

    // if (this.isUnder18(dob)) {
    //   this._shared.customPopups('Age must be 18 or older.', 1);
    //   return;
    // }

    // formData.append('date_of_birth', dob);

    formData.append('contract_id', this.contract_id);
    formData.append('contract_patient_token', this.contract_patient_token);
    console.log(formData, 'formData api');

    this._api.uploadApi(formData, 'finance/update_doc_proof').subscribe((response: any) => {
      if (response && response.body && response.body.is_error === 0) {
        const mappedData = this.getMappedExtraData();
        if (response?.body?.data?.length) {
          response.body.data.forEach((item: any) => {
            Object.assign(mappedData, item);
          });
        }
        if (this.modalType === 'UPLOAD_IDENTITY') {
          this.passEntry.emit({ success: true, body: response.body, customer_data: mappedData });
          this._shared.customPopups('Document uploaded successfully', 0);
          this.bsModalRef.hide();

        } else {

          this.currentStep = 3;
          this._shared.customPopups('Document uploaded successfully', 0);
          this._socket.emit(this._shared.socketIds.DL_LOADER, {
            token: this.token,
            loader: false,
            isDocUploaded: true,
            customer_data: mappedData
          });

        }
        this._loader.hideLoader();

      } else if (response && response.body && response.body.is_error === 1) {
          this._shared.customPopups( response.body.message || 'Failed to upload document', 1,);
        this._loader.hideLoader();
      }
    });
  }

  private isUnder18(dob: string): boolean {
    if (!dob) {
      return false;
    }

    const dobDate = new Date(`${dob}T00:00:00`);
    if (Number.isNaN(dobDate.getTime())) {
      return false;
    }

    const today = new Date();
    let age = today.getFullYear() - dobDate.getFullYear();
    const monthDiff = today.getMonth() - dobDate.getMonth();

    if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < dobDate.getDate())) {
      age--;
    }

    return age < 18;
  }

  async decodeBarcodeFromFile(file: File, fileType?: string) {
    this.activeScans++;
    try {
      await new Promise((r) => setTimeout(r, 250));

      const imageUrl = URL.createObjectURL(file);

      const result = await this.barcodeReader.decodeFromImageUrl(imageUrl);

      if (!result) {
        if (this.selectedIdType === 'drivers_license' && fileType === 'back') {
          this._shared.customPopups('Unable to scan Driver\'s License. Please upload a clear image of the back side.', 1);
          // this.removeIdentityFile('back');
        }
        return;
      }

      if (result.getBarcodeFormat() !== BarcodeFormat.PDF_417) {
        if (this.selectedIdType === 'drivers_license' && fileType === 'back') {
          this._shared.customPopups('Invalid barcode format. Please upload a valid Driver\'s License back side.', 1);
          // this.removeIdentityFile('back');
        }
        return;
      }

      const barcodeText = result.getText();

      console.log('DL Barcode Found:', barcodeText);
      this.barCodeDetected = true
      this.handleLicenseData(barcodeText);
    } catch (e) {
      console.log('Barcode not detected');
      if (this.selectedIdType === 'drivers_license' && fileType === 'back') {
        this.barCodeDetected = false
        // this._shared.customPopups('Barcode not detected. Please upload a clear image of the back side of the Driver\'s License.', 1);
        // this.removeIdentityFile('back');
      }
    } finally {
      this.activeScans--;
    }
  }

  getMappedExtraData(): ExtraDataMapped {
    if (!this.extra_data) {
      return {
        first_name: "",
        last_name: "",
        address: "",
        city: "",
        state: "",
        zip: "",
        dob: "",
        dl_number: ""
      };
    }
    else {
      return {
        first_name: this.extra_data["First Name"] || this.extra_data["Customer Given Name"] || "",
        last_name: this.extra_data["Last Name"] || this.extra_data["Customer Family Name"] || "",
        address: this.extra_data["Street Address"] || "",
        city: this.extra_data["City"] || "",
        state: this.extra_data["State"] || "",
        zip: this.extra_data["Postal Code"] || "",
        dob: this.extra_data["Date of Birth (MMDDYYYY)"] || "",
        dl_number: this.extra_data["Driver's License Number"] || ""
      };
    }
  }
  
  handleLicenseData(barcode: string) {
    if (!barcode.includes('ANSI')) {
      console.log('Not AAMVA format');
      return;
    }

    const parsed = this._shared.parseAllAAMVAKeys(barcode);
     const getField = (code: string) => {
        const match = barcode.match(new RegExp(`${code}([^\\n\\r]+)`));
        return match ? match[1].trim() : "";
      };
      const dlNumber = getField("DAQ");
      parsed["Driver's License Number"] = dlNumber
    console.log('Parsed DL Data:', parsed);

    this.extra_data = parsed;

    if (parsed && parsed['Date of Birth (MMDDYYYY)']) {
      const rawDob = parsed['Date of Birth (MMDDYYYY)'];
      if (rawDob && rawDob.length === 8) {
        this.dobData = {
          month: rawDob.substring(0, 2),
          day: rawDob.substring(2, 4),
          year: rawDob.substring(4, 8),
        };
        this.showDobError = false;
      }
    }
  }
  ngOnDestroy() {
    this._socket.emit(this._shared.socketIds.DL_LOADER, {
      token: this.token,
      loader: false,
      isDocUploaded: false,
      customer_data:{}
    });
    this._socket.disconnect();
  }

  private areFilesSame(fileA?: File, fileB?: File): boolean {
    if (!fileA || !fileB) {
      return false;
    }

    return (
      fileA.name === fileB.name &&
      fileA.size === fileB.size &&
      fileA.type === fileB.type &&
      fileA.lastModified === fileB.lastModified
    );
  }

  private resetSelectedFile(fileType: string, input: HTMLInputElement): void {
    delete this.identityFiles[fileType];
    delete this.identityPreviews[fileType];

    if (this.selectedIdType === 'drivers_license' && fileType === 'back') {
      this.barCodeDetected = false;
    }

    input.value = '';
  }
}
type ExtraDataMapped = {
  first_name: string;
  last_name: string;
  address: string;
  city: string;
  state: string;
  zip: string;
  dob: string;
  dl_front?: string;
  dl_back?: string;
  proof_of_id?: string;
  dl_number?: string;
};
